import React from "react"

import { LogoImageView } from "react-ui-components/components/LogoImageView"

import { getOptimizedAsset } from "../utils/optimizedImages"

const LOGO_DEFAULT_WIDTH = 180
const LOGO_FALLBACK_SRC = "/optimized/logo-wbox/logo-wbox-180w.png"
const logoAsset = getOptimizedAsset("src/assets/LogoWBox.png", LOGO_DEFAULT_WIDTH)

interface LogoProps {
  className?: string
  cropped?: boolean
  height?: number | string
  loading?: "eager" | "lazy"
  style?: React.CSSProperties
  width?: number | string
}

export const Logo: React.FC<LogoProps> = ({ width = 180, height = 97, style, className, loading = "lazy" }) => {
  const resolvedWidth = typeof width === "number" ? width : LOGO_DEFAULT_WIDTH
  const sizes =
    typeof resolvedWidth === "number"
      ? `(max-width: 640px) ${Math.round(resolvedWidth * 0.85)}px, ${resolvedWidth}px`
      : undefined
  const resolvedLogoAsset = getOptimizedAsset("src/assets/LogoWBox.png", resolvedWidth) || logoAsset

  return (
    <LogoImageView
      className={className}
      src={resolvedLogoAsset?.fallback || LOGO_FALLBACK_SRC}
      sources={resolvedLogoAsset?.sources}
      alt="winfacil-logo"
      width={width}
      height={height}
      loading={loading}
      style={style}
      sizes={sizes}
    />
  )
}
